import { render, staticRenderFns } from "./PlatformAuthSettings.vue?vue&type=template&id=52c5abd9&scoped=true"
import script from "./PlatformAuthSettings.vue?vue&type=script&lang=js"
export * from "./PlatformAuthSettings.vue?vue&type=script&lang=js"
import style0 from "./PlatformAuthSettings.vue?vue&type=style&index=0&id=52c5abd9&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5abd9",
  null
  
)

export default component.exports